export default Object.freeze({
  school: 1,
  organization: 2,
  other: 3,
});
